document.addEventListener('DOMContentLoaded', () => {
  const productContainer = document.querySelector('.product-template');
  const inventoryQuantityLabel = document.querySelectorAll('.js-inventory-quantity-label');
  const lowStockLimit = inventoryQuantityLabel[0]?.dataset.lowStockLimit ? parseInt(inventoryQuantityLabel[0].dataset.lowStockLimit) : 0;

  if (inventoryQuantityLabel.length) {
    $(productContainer).on('variantChange', (e) => {
      if (e.variant) {
        const variantId = e.variant.id;
        const selectedSizeLabel = document.getElementById(`label-variant-${variantId}`);
        let selectedSizeQuantity = selectedSizeLabel.getAttribute('data-inventory-quantity');

        if (selectedSizeQuantity) {
          selectedSizeQuantity = parseInt(selectedSizeQuantity);

          inventoryQuantityLabel.forEach(el => {
            el.classList.toggle('hidden', selectedSizeQuantity <= 0 || selectedSizeQuantity > lowStockLimit);
            el.ariaHidden = (selectedSizeQuantity <= 0 || selectedSizeQuantity > lowStockLimit).toString();
          })
        }
      }
    });
  }

  // shop by look
  const itemAddedCallback = (item) => {
    ShopifyAPI.getCart(ShopifyAPI.updateCartItemsCount);
    setTimeout(() => {
      ajaxCart.load();
    }, 300);
  }

  $('.product__meta__shop-by-look').on('submit', 'form', function(e) {
    e.preventDefault();
    window.ShopifyAPI.addItemFromForm(
      e.currentTarget,
      itemAddedCallback,
      // () => console.log('Error adding item to cart.'),
    );
  }).on('change', 'select', function(e) {
    const select = $(e.currentTarget);
    const parent = select.closest('.product__meta__shop-by-look__product');
    const priceElement = parent.find('.product__meta__shop-by-look__product__price');
    const price = select.find('option:selected').data('price');

    priceElement.text(price);
  });
})
